
(function() {
  var result = { translations: { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.1325"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1325",
    "ar-eg": "static-7.1325",
    "bg": "static-7.1325",
    "bn": "static-7.1325",
    "ca-es": "static-7.1325",
    "cs": "static-7.1325",
    "da": "static-7.1325",
    "de": "static-7.1325",
    "el": "static-7.1325",
    "en-gb": "static-7.1325",
    "en": "static-7.1325",
    "es-mx": "static-7.1325",
    "es": "static-7.1325",
    "et": "static-7.1325",
    "fi": "static-7.1325",
    "fr-ca": "static-7.1325",
    "fr": "static-7.1325",
    "he-il": "static-7.1325",
    "hi": "static-7.1325",
    "hr": "static-7.1325",
    "hu": "static-7.1325",
    "id": "static-7.1325",
    "it": "static-7.1325",
    "ja": "static-7.1325",
    "ko": "static-7.1325",
    "lt": "static-7.1325",
    "ms": "static-7.1325",
    "nl": "static-7.1325",
    "no": "static-7.1325",
    "pl": "static-7.1325",
    "pt-br": "static-7.1325",
    "pt-pt": "static-7.1325",
    "ro": "static-7.1325",
    "ru": "static-7.1325",
    "sk": "static-7.1325",
    "sl": "static-7.1325",
    "sv": "static-7.1325",
    "th": "static-7.1325",
    "tl": "static-7.1325",
    "tr": "static-7.1325",
    "uk": "static-7.1325",
    "vi": "static-7.1325",
    "x-pseudo": "static-7.1325",
    "zh-cn": "static-7.1325",
    "zh-hk": "static-7.1325",
    "zh-tw": "static-7.1325"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.1325'}); }
})();


